import React from "react";
import {connect} from "react-redux";
import {get} from '../../utils/api';
import {Link} from 'react-router-dom';
import {deleteBrand} from "../../actions/brandActions";
import Loading from '../Shared/Loading';

class EmptyBrands extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            brands: [],
            loading: true,
        };
        this.getBrands = this.getBrands.bind(this);
        this.deleteBrands = this.deleteBrands.bind(this);
    }
    componentDidMount() {
        this.getBrands();
     };
     getBrands() {
        return get('manage/brands')
            .then((res) => {
                this.setState({
                    brands: res.result,
                    loading: false,
                })
            });
    }
    deleteBrands(bid) {
        const res = window.confirm('Are you sure you want to delete this Brand?');
        if (res) {
            this.props.dispatch(deleteBrand(bid)).then(() => {
                this.getBrands();
            });
        }
    }

    render(){
        return(
            <div className="campaign-info">
                <h2># of Empty Brands: {this.state.brands.length} </h2>
                {this.state.loading ?  <Loading /> :
                <table className="table blank-table">
                    <thead>
                        <tr>
                            <th>Brand Name</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.brands.length !== 0 ? this.state.brands.map((brand, k) => {
                        return(
                            <tr key={k}>
                                <td><Link key={k} to={`/brand/${brand.id}`}>{brand.name}</Link></td>
                                <td>
                                    <button className="button button--red mr-10"
                                    onClick={() => this.deleteBrands(brand.id)}>Delete Brand
                                    </button>
                                </td>
                            </tr>
                        )
                    }) : <tr><td style={{flexBasis: '100%'}}><h3>There are no empty brands.</h3></td></tr>}
                    </tbody>
                </table>
                }
            </div>
        )
    }
}
export default  connect(null)(EmptyBrands);